// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nx9H5mLTEC {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.nx9H5mLTEC h4 {
  line-height: 3em;
}
.nx9H5mLTEC .AgpzC1w4to {
  float: left;
  width: 100%;
}
.nx9H5mLTEC .wZM4T2ZN6G {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.nx9H5mLTEC .wZM4T2ZN6G:hover {
  cursor: pointer;
}
.nx9H5mLTEC .wZM4T2ZN6G:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.f8Ftjqo4b4 .olj8jEQ6xq:focus {
  outline: none;
}
.f8Ftjqo4b4 .olj8jEQ6xq.tyF_P1EfIx.Siymg9SQXq {
  background: #375A88;
}
.f8Ftjqo4b4 .olj8jEQ6xq.tyF_P1EfIx.Siymg9SQXq span {
  color: #fff;
}
.f8Ftjqo4b4 .Siymg9SQXq {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.f8Ftjqo4b4 .Siymg9SQXq:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.f8Ftjqo4b4 input {
  height: 38px;
  min-width: 220px;
}
.wZM4T2ZN6G.OEqXf4wooI {
  background: #410102;
}
.wZM4T2ZN6G.vmPmUWfvYA {
  background: #911318;
}
.wZM4T2ZN6G.OKem7gVIWE {
  background: #D8293B;
}
.wZM4T2ZN6G.rd_e3_AmZf {
  background: #F2373C;
}
.wZM4T2ZN6G.JFAPivp8ME {
  background: #FC4448;
}
.wZM4T2ZN6G.rhp5KqzVF1 {
  background: #ED535E;
}
.wZM4T2ZN6G.Eod4S_SXWH {
  background: #E34926;
}
.wZM4T2ZN6G.LLgzmwbPvf {
  background: #FC562B;
}
.wZM4T2ZN6G.iQtJhAh46b {
  background: #FC6722;
}
.wZM4T2ZN6G.yd5dztxYpQ {
  background: #FD7F24;
}
.wZM4T2ZN6G.UNV4HmBPrK {
  background: #FD8D26;
}
.wZM4T2ZN6G.hTIXdGXD4k {
  background: #EC9C3E;
}
.wZM4T2ZN6G.MQGknokHKk {
  background: #0e673a;
}
.wZM4T2ZN6G.r0soXyHzgc {
  background: #208740;
}
.wZM4T2ZN6G.poPBkMs8xB {
  background: #239718;
}
.wZM4T2ZN6G.yUKTzaxfso {
  background: #55A84D;
}
.wZM4T2ZN6G.d0Y2Z6SnKX {
  background: #4BBE5A;
}
.wZM4T2ZN6G.hY8j7W6hpN {
  background: #0CCA6A;
}
.wZM4T2ZN6G.EP3WHKX9D1 {
  background: #0A3C64;
}
.wZM4T2ZN6G.J1avjMZykX {
  background: #0d487a;
}
.wZM4T2ZN6G.dr4OOaOYxv {
  background: #10538d;
}
.wZM4T2ZN6G.PqaWIvzKQX {
  background: #115A99;
}
.wZM4T2ZN6G.VXOAzZ8zqM {
  background: #3387E2;
}
.wZM4T2ZN6G.cFUX9bDrg2 {
  background: #1BA9CF;
}
.wZM4T2ZN6G.G82uDDq40i {
  background: #d27c02;
}
.wZM4T2ZN6G.mxtMvERiqD {
  background: #fb9402;
}
.wZM4T2ZN6G.NWaXPjgxEf {
  background: #FD9B30;
}
.wZM4T2ZN6G.iuQ1SyYhIv {
  background: #FDBE2D;
}
.wZM4T2ZN6G.FzyuZGpiVv {
  background: #FED831;
}
.wZM4T2ZN6G.Jj0FzSU5V5 {
  background: #FFFD38;
}
.wZM4T2ZN6G.BgIMrnCOfy {
  background: #2D215C;
}
.wZM4T2ZN6G.y0a5vzqPnR {
  background: #483C83;
}
.wZM4T2ZN6G.mDi8bYqNZA {
  background: #58518d;
}
.wZM4T2ZN6G.h1OZfQx9EM {
  background: #7068A9;
}
.wZM4T2ZN6G.fmtTjXGBFC {
  background: #7f78b2;
}
.wZM4T2ZN6G.q6KVdWn7O3 {
  background: #8f88bc;
}
.wZM4T2ZN6G.rKeuHpxTd7 {
  background: #000;
}
.wZM4T2ZN6G.W8kDqcJz1u {
  background: #282626;
}
.wZM4T2ZN6G.M5Ixr2DqAu {
  background: #242222;
}
.wZM4T2ZN6G.sDw82kx9oj {
  background: #353838;
}
.wZM4T2ZN6G.I7n0mprWV5 {
  background: #666;
}
.wZM4T2ZN6G.u2bXJ9xiPv {
  background: #999;
}
.Ah0H_e2F3z {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.Ah0H_e2F3z .oy3fIYqkmI {
  display: none;
}
.g4xcX9M7Z8 {
  flex: 1;
}
.g4xcX9M7Z8 .ENHLbrfau7 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.g4xcX9M7Z8 .ENHLbrfau7 .bnUiiUGNG9 {
  display: flex;
  gap: 20px;
}
.g4xcX9M7Z8 .ENHLbrfau7 .bnUiiUGNG9 .nIz7GvNasR {
  border-bottom: 1px solid #383838;
  color: #383838;
  cursor: pointer;
  font-size: 11px;
}
.g4xcX9M7Z8 .ENHLbrfau7 .bnUiiUGNG9 .nIz7GvNasR > i {
  font-size: 11px;
}
.g4xcX9M7Z8 .ENHLbrfau7 .bnUiiUGNG9 .qCUrf8qOEg {
  border-bottom: 1px solid #383838;
  color: #383838;
  cursor: pointer;
  font-size: 11px;
}
.g4xcX9M7Z8 .ENHLbrfau7 .bnUiiUGNG9 .qCUrf8qOEg .WOKLiTN_is {
  margin-right: 4px;
}
.g4xcX9M7Z8 .ENHLbrfau7 .EvZp2X7AK6 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.g4xcX9M7Z8 .ENHLbrfau7 .rSch9O1DmK {
  text-transform: uppercase;
  font-weight: bold;
  width: 254px;
  font-size: 12px;
}
.g4xcX9M7Z8 .ENHLbrfau7 .NBFA4_sDk8 {
  height: 16px;
  width: 74px;
}
.g4xcX9M7Z8 .ENHLbrfau7 .iSLXjplsTs {
  min-width: 80px;
  margin-bottom: 16px;
}
.g4xcX9M7Z8 .ENHLbrfau7 .DedQ9wgHwN.DedQ9wgHwN {
  background: none;
  position: relative;
  color: black;
  font-size: 11px;
  text-transform: capitalize;
  font-weight: 400;
}
.g4xcX9M7Z8 .ENHLbrfau7 .DedQ9wgHwN.DedQ9wgHwN::after {
  content: '';
  text-decoration: underline;
  border-bottom: 1px solid #707070;
  width: 85%;
  height: 60%;
  position: absolute;
}
.g4xcX9M7Z8 .ENHLbrfau7 .DedQ9wgHwN.DedQ9wgHwN:hover {
  background: none;
  color: black;
}
.g4xcX9M7Z8 .umwI2iX_Se > :first-child > :first-child {
  border-top: 1px solid #E3E9F1 !important;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.jH07dtF7Zq.jH07dtF7Zq {
  display: flex;
  padding: 8px 16px;
  width: 74%;
}
.jH07dtF7Zq.jH07dtF7Zq .Q2SjmSIOoB {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 2 1 0;
  padding-right: 4px;
}
.jH07dtF7Zq.jH07dtF7Zq .Q2SjmSIOoB .sKYdn_q7TM {
  height: 16px;
  width: 16px;
  border-radius: 50px;
  margin-right: 4px;
}
.jH07dtF7Zq.jH07dtF7Zq .Q2SjmSIOoB .G10xDqJ3NP {
  text-transform: uppercase;
  margin-right: 12px;
  font-size: 11px;
}
.jH07dtF7Zq.jH07dtF7Zq .Q2SjmSIOoB .F9GeszmreE {
  background-color: #FFB703;
  z-index: 1000;
}
.jH07dtF7Zq.jH07dtF7Zq .Q2SjmSIOoB .AXe78RwSyZ {
  display: flex;
  align-items: flex-start;
}
.jH07dtF7Zq.jH07dtF7Zq .Q2SjmSIOoB .AXe78RwSyZ .UEoGXoGpi7 {
  border-radius: 50%;
  height: 42px;
  width: 42px;
  margin-right: 8px;
  margin-top: 4px;
}
.jH07dtF7Zq.jH07dtF7Zq .Q2SjmSIOoB .AXe78RwSyZ .zMWcMQdCof {
  display: flex;
  flex-direction: column;
  font-size: 11px;
}
.jH07dtF7Zq.jH07dtF7Zq .Q2SjmSIOoB .AXe78RwSyZ .zMWcMQdCof .piGtuH3X1M {
  text-transform: uppercase;
  font-weight: bold;
}
.jH07dtF7Zq.jH07dtF7Zq .Q2SjmSIOoB .NBFA4_sDk8 {
  height: 16px;
}
.jH07dtF7Zq.jH07dtF7Zq .iCBi9d4sfM {
  flex: 0 0 80px;
  margin-top: 4px;
  max-width: 80px;
  width: 80px;
}
.jH07dtF7Zq.jH07dtF7Zq .HZAfxdFVjA {
  margin-top: -8px;
  margin-left: 10px;
  flex: 1 1 0;
  min-width: 176px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `nx9H5mLTEC`,
	"color-row": `AgpzC1w4to`,
	"color-tile": `wZM4T2ZN6G`,
	"picker-component": `f8Ftjqo4b4`,
	"picker-element": `olj8jEQ6xq`,
	"active": `tyF_P1EfIx`,
	"btn": `Siymg9SQXq`,
	"red-1": `OEqXf4wooI`,
	"red-2": `vmPmUWfvYA`,
	"red-3": `OKem7gVIWE`,
	"red-4": `rd_e3_AmZf`,
	"red-5": `JFAPivp8ME`,
	"red-6": `rhp5KqzVF1`,
	"orange-1": `Eod4S_SXWH`,
	"orange-2": `LLgzmwbPvf`,
	"orange-3": `iQtJhAh46b`,
	"orange-4": `yd5dztxYpQ`,
	"orange-5": `UNV4HmBPrK`,
	"orange-6": `hTIXdGXD4k`,
	"green-1": `MQGknokHKk`,
	"green-2": `r0soXyHzgc`,
	"green-3": `poPBkMs8xB`,
	"green-4": `yUKTzaxfso`,
	"green-5": `d0Y2Z6SnKX`,
	"green-6": `hY8j7W6hpN`,
	"blue-1": `EP3WHKX9D1`,
	"blue-2": `J1avjMZykX`,
	"blue-3": `dr4OOaOYxv`,
	"blue-4": `PqaWIvzKQX`,
	"blue-5": `VXOAzZ8zqM`,
	"blue-6": `cFUX9bDrg2`,
	"yellow-1": `G82uDDq40i`,
	"yellow-2": `mxtMvERiqD`,
	"yellow-3": `NWaXPjgxEf`,
	"yellow-4": `iuQ1SyYhIv`,
	"yellow-5": `FzyuZGpiVv`,
	"yellow-6": `Jj0FzSU5V5`,
	"purple-1": `BgIMrnCOfy`,
	"purple-2": `y0a5vzqPnR`,
	"purple-3": `mDi8bYqNZA`,
	"purple-4": `h1OZfQx9EM`,
	"purple-5": `fmtTjXGBFC`,
	"purple-6": `q6KVdWn7O3`,
	"black-1": `rKeuHpxTd7`,
	"black-2": `W8kDqcJz1u`,
	"black-3": `M5Ixr2DqAu`,
	"black-4": `sDw82kx9oj`,
	"black-5": `I7n0mprWV5`,
	"black-6": `u2bXJ9xiPv`,
	"picker-theme": `Ah0H_e2F3z`,
	"arrow-regular": `oy3fIYqkmI`,
	"reviewStages": `g4xcX9M7Z8`,
	"header": `ENHLbrfau7`,
	"stage-buttons": `bnUiiUGNG9`,
	"review-setting-btn": `nIz7GvNasR`,
	"expand-all-btn": `qCUrf8qOEg`,
	"expand-all-btn__icon": `WOKLiTN_is`,
	"status": `EvZp2X7AK6`,
	"headerTitle": `rSch9O1DmK`,
	"chipButton": `NBFA4_sDk8`,
	"processStatus": `iSLXjplsTs`,
	"addReviewButton": `DedQ9wgHwN`,
	"stages": `umwI2iX_Se`,
	"accorDetails": `jH07dtF7Zq`,
	"reviewers": `Q2SjmSIOoB`,
	"reviewerAvatar": `sKYdn_q7TM`,
	"reviewerName": `G10xDqJ3NP`,
	"forwardIcon": `F9GeszmreE`,
	"avtTooltip": `AXe78RwSyZ`,
	"avtHover": `UEoGXoGpi7`,
	"avtTooltipInfo": `zMWcMQdCof`,
	"avtName": `piGtuH3X1M`,
	"processStatusDetails": `iCBi9d4sfM`,
	"statusDetails": `HZAfxdFVjA`
};
export default ___CSS_LOADER_EXPORT___;
